import React from 'react';
import {
  CrossIcon, DeleteIcon, IconButton, ImportIcon,
  Pane, Position, SideSheet, Strong, Tooltip,
} from 'evergreen-ui';
import { createUseStyles } from 'react-jss';

import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { useGetMessageAttachmentsQuery, useGetMessageByIdQuery } from 'Services/api/messageApi';

// todo перенести куда-то в утилс вместе с prefixImageBase64ByFileName
export const noImage = 'data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTt9Cjwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTTExNS44LDExMC42bDMwLDMwLjNIMTU4YzIuNSwwLDQuNi0yLjEsNC42LTQuNnYtMTIuNGwtMjkuOS0zMC4yTDExNS44LDExMC42eiI+PC9wYXRoPjxnPjxnPjxwYXRoIGQ9Ik0zNi42LDEzNS4zVjEwOWwzNi41LTM2LjlsMjQuMSwyNC4zbDIuOC0yLjhMNzQuNSw2Ny44Yy0wLjgtMC44LTIuMS0wLjgtMi44LDBsLTM1LjEsMzUuNVY1OC41YzAtMi41LDIuMS00LjYsNC42LTQuNiAgICBoOTguNmw0LTRINDEuMWMtNC43LDAtOC42LDMuOS04LjYsOC42djc2LjhjMCw0LjcsMy45LDguNiw4LjYsOC42aDguNmw0LTRINDEuMUMzOC42LDEzOS45LDM2LjYsMTM3LjgsMzYuNiwxMzUuM3oiPjwvcGF0aD48cGF0aCBkPSJNMTU4LDQ5LjloLTIuOGwtNCw0aDYuOGMyLjUsMCw0LjYsMi4xLDQuNiw0LjZ2NTguN2wtMjguNS0yOC44Yy0wLjQtMC40LTAuOS0wLjYtMS40LTAuNmMwLDAsMCwwLDAsMCAgICBjLTAuNSwwLTEsMC4yLTEuNCwwLjZMMTEzLDEwNi43bC03LjMtNy40bC0yLjgsMi44bDM3LjMsMzcuN2gtNzVsLTQsNEgxNThjNC43LDAsOC42LTMuOSw4LjYtOC42VjU4LjUgICAgQzE2Ni42LDUzLjcsMTYyLjcsNDkuOSwxNTgsNDkuOXogTTE2Mi42LDEzNS4zYzAsMi41LTIuMSw0LjYtNC42LDQuNmgtMTIuMmwtMzAtMzAuM2wxNi44LTE2LjlsMjkuOSwzMC4yVjEzNS4zeiI+PC9wYXRoPjwvZz48cmVjdCB4PSIxNy4yIiB5PSI5Ny4yIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjcwNzEgLTAuNzA3MSAwLjcwNzEgMC43MDcxIC00MC43NzgxIDk5Ljk4NTcpIiB3aWR0aD0iMTY2LjIiIGhlaWdodD0iNCI+PC9yZWN0PjwvZz48L3N2Zz4=';

/** // todo вынести куда-нибудь
 * Получаем для крартинки префикс base64 ("data:image/${type};base64,") по расширению из имени файла.
 * @param {string} имя файла с расширением
 * @return {string|null} префикс для base64, если картинка, иначе null
 */
export function prefixImageBase64ByFileName(fileName) {
  let type = '';
  const imageExp = {
    'svg+xml': 'svg',
    jpeg: '.jpg, .jpeg, .jfif, .pjpeg, .pjp',
    png: 'png',
    gif: 'gif',
  };
  let expansion = fileName.split('.');
  expansion = expansion[expansion.length - 1].toLowerCase();
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in imageExp) {
    if (imageExp[prop].includes(expansion)) {
      type = prop;
      break;
    }
  }
  return type ? `data:image/${type};base64,` : null;
}

const useStyles = createUseStyles({
  images: {
    marginTop: '.5rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    // gridTemplateColumns: 'repeat(auto-fit, 300px)',
    gridGap: '.5rem',
    justifyContent: 'center',
  },
  imageNameWrap: {
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '.5rem',
  },
  imageName: {
    textOverflow: 'ellipsis',
    whiteSpace: 'wrap',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '300px', // как в images у gridTemplateColumns min
  },
  cursorPointer: {
    cursor: 'pointer',
  },
});

/**
 * Выгрузка и отображение вложений сеткой для сообщения/наблюдения.
 * @param {string|number} messageId айди сообщения/наблюдения для которого нужен XML
 * @param {array} [additionalAttachments] дополнительные вложения помимо выгружаемых (нужно в наблюдении в доп инфо)
 * Нужны: name, id, type (например image/*), data(base64 без 'data:${...};base64,') remove - функция если нужно удалить объкт.
 * @param {boolean} [canOpenFull=true] true - разрешает при нажатии на картинку ее открытие на весь экран
 * @param {boolean} [canDownload=true] true - разрешает скачивать вложения
 * @param {boolean} [hasLoading=true] true - показывать крутилку при загрузки данных
 * @returns {JSX.Element}
 */
export default function MessageAttachments({
  additionalAttachments, // дополнительные картинки и файлы
  messageId,
  useGetMessageFileById = useGetMessageByIdQuery,
  canOpenFull = true,
  canDownload = true,
  hasLoading = true,
}) {
  const classes = useStyles();
  const [openedImage, setOpenedImage] = React.useState(null);

  // todo временная заглушка, так как нет в ресте графа
  // const { data: messageAttachments, isFetching: isFetchingMessageAttachments } = useGetMessageAttachmentsQuery(messageId);
  const { data: { content: messageAttachments = [] } = {}, isFetching: isFetchingMessageAttachments } = useGetMessageFileById(messageId);

  // если есть доп вложения, то их тоже нужно отобразить
  const attachments = React.useMemo(() => (
    additionalAttachments?.length
      ? [...messageAttachments.filter(({ attachment }) => attachment), ...additionalAttachments]
      : messageAttachments.filter(({ attachment }) => attachment)
  ), [additionalAttachments, messageAttachments]);

  const closeImage = React.useCallback(() => setOpenedImage(null), []);

  const downloadAttachment = React.useCallback((attachmentId) => {
    if (canDownload) {
      const link = document.createElement('a');
      link.href = `${process.env.REACT_APP_API_PREFIX}/message/${messageId}/attachment/${attachmentId}/data`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [canDownload, messageId]);

  if (hasLoading && isFetchingMessageAttachments) return <SuspenseSpinner />;
  return (
    attachments?.length
      ? (
        <>
          <Strong size={500} display="block" textAlign="center"> Вложения </Strong>
          <div className={classes.images}>
            {
              attachments?.map((attachment) => {
                const {
                content, filename, name, remove,
                } = attachment;
                const prefix = prefixImageBase64ByFileName(filename || name);
                const base64 = prefix ? `${prefix}${content.data}` : noImage;

                // Там где нет remove сделать download файла на комп
                return (
                  <Pane key={attachment.id} background="tint1" elevation={1}>
                    <Pane className={classes.imageNameWrap} padding={(remove || canDownload) ? 2 : '.5rem'}>
                      <Strong>{attachment.name}</Strong>
                      {
                        remove
                          ? (
                            <Tooltip content="Удалить">
                              <IconButton
                                appearance="minimal"
                                iconSize={20}
                                icon={CrossIcon}
                                intent="danger"
                                onClick={remove}
                              />
                            </Tooltip>
                          )
                          : (
                            <Tooltip content="Скачать">
                              <IconButton
                                appearance="minimal"
                                iconSize={20}
                                icon={<ImportIcon color="info" />}
                                onClick={() => downloadAttachment(attachment.id)}
                              />
                            </Tooltip>
                          )
                      }
                    </Pane>
                    {
                      canOpenFull
                        ? (
                          <Tooltip display="none" position={Position.BOTTOM} content={base64 === noImage ? 'Произвольный файл' : 'Открыть'}>
                            <img
                              aria-hidden="true"
                              className={`${classes.image} ${base64 === noImage ? '' : classes.cursorPointer}`}
                              src={base64}
                              alt={attachment.name}
                              onClick={base64 === noImage ? undefined : (() => setOpenedImage(base64))}
                            />
                          </Tooltip>
                        )
                        : (
                          <img
                            className={classes.image}
                            src={base64}
                            alt={attachment.name}
                          />
                        )
                    }
                  </Pane>
                );
              })
            }
          </div>
          { // открытие картинки на весь экран
            canOpenFull && openedImage
              ? <FullImage image={openedImage} closeImage={closeImage} />
              : null
          }
        </>
      )
      : null
  );
}

const useStylesFullImage = createUseStyles({
  imageWrap: {
    display: 'grid',
    cursor: 'pointer',
    position: 'relative',
    justifyItems: 'center',
    alignItems: 'center',
    height: '100%',
  },
  image: {
    maxWidth: '100vw',
    maxHeight: '90vh',
  },
  buttonRightTop: {
    top: '1rem',
    right: '1rem',
    zIndex: 3,
    position: 'absolute',
    pointerEvents: 'none',
    padding: '1px',
    borderRadius: '1px',
    cursor: 'pointer',
  },
});

/**
 * Открытие картинки на весь экран с помощью <SideSheet />.
 * Закрывать можно нажатием в любое место.
 * @param {string} image base64
 * @param {function} closeImage функция для закрытия картинки
 * @returns
 */
function FullImage({ image, closeImage }) {
  const classes = useStylesFullImage();
  return (
    <SideSheet
      title="Нажмите для закрытия"
      position={Position.LEFT}
      containerProps={{
        background: 'rgba(0,0,0,0.5) !important',
      }}
      width="100vw"
      isShown
      onCloseComplete={closeImage}
    >
      <div
        aria-hidden="true"
        className={classes.imageWrap}
        onClick={closeImage}
      >
        <DeleteIcon
          className={classes.buttonRightTop}
          size={30}
          color="white"
        />
        <img
          className={classes.image}
          title="Нажмите для закрытия"
          src={image}
          alt={image}
        />
      </div>
    </SideSheet>
  );
}
